import React from 'react'
import { Form, Input, Button, Icon } from 'antd'

const FormItem = Form.Item

class MfaForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.state = { code: '' }
    this.handleOnSubmit = this.handleOnSubmit.bind(this)
    this.handleCodeChange = this.handleCodeChange.bind(this)
  }

  handleOnSubmit(e) {
    e.preventDefault()
    if (this.state.code.length === 6) {
      this.props.onSubmit(this.state.code)
    }
  }

  handleCodeChange(e) {
    const value = e.target.value.replace(/\D/g, '').slice(0, 6)
    this.setState({ code: value })
  }

  render() {
    return (
      <Form onSubmit={this.handleOnSubmit}>
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <Icon type='safety' style={{ fontSize: 48, color: '#1890ff' }} />
          <h3 style={{ marginTop: 16 }}>Two-Factor Authentication</h3>
          <p style={{ color: '#666' }}>Enter the 6-digit code from your authenticator app</p>
        </div>
        <FormItem>
          <Input
            prefix={<Icon type='lock' style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder='000000'
            value={this.state.code}
            onChange={this.handleCodeChange}
            maxLength={6}
            style={{ textAlign: 'center', fontSize: 24, letterSpacing: 8 }}
            autoFocus
          />
        </FormItem>
        <FormItem>
          <Button
            loading={this.props.isLoading}
            type='primary'
            htmlType='submit'
            style={{ width: '100%' }}
            size='large'
            disabled={this.state.code.length !== 6}
          >
            Verify
          </Button>
        </FormItem>
        <FormItem>
          <Button
            type='link'
            onClick={this.props.onCancel}
            style={{ width: '100%' }}
          >
            Back to Login
          </Button>
        </FormItem>
      </Form>
    )
  }
}

export default MfaForm

